
    /*global server*/
    import { defineComponent } from 'vue';
    import { useResultsStore } from '../../stores/citation-search-results';
    import { Form, Field } from "vee-validate";
    import * as yup from "yup";
    import { AxiosResponse } from 'axios';


    export default defineComponent({
        components: {
            Form,
            Field,
        },
        data() {
            const schema = yup.object().shape({
                form: yup.object({
                    LastName: yup.string().required("Last name is required"),
                })
            });

            return {
                form: {
                    TicketNumber: '',
                    DocketNumber: '',
                    LastName: '',
                    FirstName: '',
                    DateOfBirth: ''
                } as server.CitationSearch,
                isCitationHelpModalActive: false,
                isCaseDocketHelpModalActive: false,
                isSearching: false,
                results: useResultsStore(),
                showSearchMethodError: false,
                showCaseNotFound: false,
                searchMessageError: "No open/payable case was found.",
                schema,
                masks: {
                    dateMask: '##/##/####',
                }
            }
        },
        methods: {
            ticketNumberRequired(): boolean {
                return ((!this.form.DateOfBirth || !this.form.DocketNumber || !this.form.FirstName) && !this.form.TicketNumber) ? true : false;
            },
            onSubmit() {
                if (this.ticketNumberRequired()) {
                    this.showCaseNotFound = false;
                    this.showSearchMethodError = true;
                    return false;
                }

                this.showSearchMethodError = false;
                this.isSearching = true;

                this.$axios.post('search/search', this.form).then((response: AxiosResponse<server.CitationSearchResult>) => {
                    if (response.data.Overview.InquiryResult == "OK") {
                        this.results.setResults(response.data);
                        this.results.setCheckoutTimer(new Date());
                        this.$router.push({ name: 'results' })
                    } else {
                        this.searchMessageError = response.data.Overview.InquiryResult || "No open/payable case was found.";
                        this.showCaseNotFound = true;
                    }
                }).finally(() => {
                    this.isSearching = false;
                })
            },
            clearfields() {
                this.form.TicketNumber = '';
                this.form.DocketNumber = '';
                this.form.LastName = '';
                this.form.FirstName = '';
                this.form.DateOfBirth = '';
                this.showSearchMethodError = false;
                (this.$refs.formValidator as any).resetForm();
            }
        },
    });